import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { string, oneOf, bool } from 'prop-types';
import { ActivityColorPaletteLight, badgesMetadata } from '../..';
import { ContentWrapper, Category, SkeletonWrapper, ActivityBadgeHeaderWrapper } from './ActivityBadgeHeader.styles';
import { renderBadge, renderLockedBadge } from '../../Utils/renderBadge';
import { H4 } from '../Fonts/Fonts.styles';
export const ActivityBadgeHeader = _ref => {
  let {
    type,
    alignment,
    headlineElement,
    isLocked
  } = _ref;
  const {
    category
  } = badgesMetadata[type];
  const renderUnlockedState = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderBadge(type), /*#__PURE__*/React.createElement(ActivityBadgeHeaderWrapper, {
      as: headlineElement
    }, /*#__PURE__*/React.createElement(H4, {
      "data-test-id": "name"
    }, badgesMetadata[type].name), /*#__PURE__*/React.createElement(Category, {
      type: category
    }, category)));
  };
  const renderSkeleton = () => {
    return /*#__PURE__*/React.createElement(SkeletonWrapper, {
      colour: ActivityColorPaletteLight[category.toLowerCase()]
    }, renderLockedBadge(category), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
      animation: false,
      variant: "rect",
      width: 100,
      height: 16
    }), /*#__PURE__*/React.createElement(Skeleton, {
      animation: false,
      variant: "rect",
      width: 60,
      height: 16
    })));
  };
  return /*#__PURE__*/React.createElement(ContentWrapper, {
    alignment: alignment
  }, !isLocked && renderUnlockedState(), isLocked && renderSkeleton());
};
ActivityBadgeHeader.propTypes = {
  type: oneOf(Object.keys(badgesMetadata)).isRequired,
  alignment: oneOf(['start', 'center', 'end']),
  headlineElement: string,
  isLocked: bool
};
ActivityBadgeHeader.defaultProps = {
  alignment: 'start',
  headlineElement: null,
  isLocked: false
};